export const trCommon = {
  // Header
  home: "Anasayfa",
  services: "Hizmetler",
  reservation: "Rezervasyon",
  about: "Hakkımızda",
  blog: "Blog",
  contact: "İletişim",
  myReservation: "Rezervasyonlarım",
  
  // Hero
  heroTitle: "Türkiye'de Tatilinizi Unutulmaz Kılın",
  heroSubtitle: "Transfer, Özel Turlar, Tekne Turları, Araç Kiralama ve daha fazlası…",
  
  // Services
  transferService: "Transfer Hizmeti",
  privateTours: "Özel Turlar",
  groupTours: "Grup Turları",
  boatTours: "Yat Kiralama",
  carRental: "Araç Kiralama",
  villaRental: "Villa Kiralama",
  
  // Transfer Page
  transferServices: "Transfer Hizmetleri",
  transferHeroDesc: "Havalimanı transferi, şehirlerarası transfer ve VIP karşılama hizmetleri ile konforlu yolculuk deneyimi",
  transferOptions: "Transfer Seçeneklerimiz",
  transferOptionsDesc: "İhtiyacınıza uygun transfer hizmetini seçin",
  airportHotel: "Havalimanı - Otel",
  airportHotelDesc: "Havalimanından otelinize konforlu transfer",
  hotelAirport: "Otel - Havalimanı",
  hotelAirportDesc: "Otelinizden havalimanına güvenli transfer",
  intercityTransfer: "Şehirlerarası Transfer",
  intercityTransferDesc: "Türkiye'nin her yerine transfer hizmeti",
  vipWelcome: "VIP Karşılama",
  vipWelcomeDesc: "Özel karşılama ve VIP transfer hizmeti",
  chauffeurService: "Şoförlü Saatlik Araç Kiralama",
  chauffeurServiceDesc: "Profesyonel şoför ile saatlik araç kiralama hizmeti, şehir içi geziler ve özel etkinlikler için ideal",
  ourFleet: "Araç Filomuz",
  ourFleetDesc: "İhtiyacınıza uygun lüks ve konforlu araçlar",
  economySedanName: "Ekonomik Sedan",
  comfortSedanName: "Konfor Sedan",
  mercedesVitoName: "Mercedes Vito VIP",
  mercedesSprinterName: "Mercedes Sprinter",
  minibusName: "Minibüs 15+1",
  busName: "Otobüs 46 Kişilik",
  passengers: "Kişi Sayısı",
  luggage: "Bavul",
  airConditioning: "Klima",
  comfortableSeats: "Konforlu Koltuklar",
  experiencedDriver: "Deneyimli Şoför",
  premiumAC: "Premium Klima",
  leatherSeats: "Deri Koltuklar",
  vipDriver: "VIP Şoför",
  waterService: "Su İkramı",
  vipInterior: "VIP İç Dizayn",
  largeLuggage: "Geniş Bagaj",
  premiumComfort: "Premium Konfor",
  refreshmentService: "İkram Servisi",
  spaciousInterior: "Geniş İç Mekan",
  comfortableJourney: "Konforlu Yolculuk",
  professionalDriver: "Profesyonel Şoför",
  wideSeats: "Geniş Koltuklar",
  luggageCompartment: "Bagaj Bölümü",
  premiumSeats: "Premium Koltuklar",
  wcAvailable: "WC",
  tvAvailable: "TV",
  largeLuggageSpace: "Geniş Bagaj",
  
  // Reservation Form
  transferReservation: "Transfer Rezervasyonu",
  transferType: "Transfer Tipi",
  selectTransferType: "Transfer tipi seçin",
  from: "Nereden",
  to: "Nereye",
  departurePoint: "Kalkış noktası",
  arrivalPoint: "Varış noktası",
  date: "Tarih",
  time: "Saat",
  flightCode: "Uçuş Kodu (Opsiyonel)",
  flightCodePlaceholder: "Örn: TK1234",
  passengerInfo: "Yolcu Bilgileri",
  addPassenger: "Yolcu Ekle",
  firstName: "Ad",
  lastName: "Soyad",
  phoneNumber: "Telefon Numarası",
  phonePlaceholder: "+90 555 123 45 67",
  luggageCount: "Bavul Sayısı",
  childSeat: "Çocuk Koltuğu",
  notNeeded: "Gerekmiyor",
  pieces: "Adet",
  vehicleSelection: "Araç Seçimi",
  selectVehicle: "Araç seçin",
  roundTrip: "Gidiş-Dönüş Transfer",
  extraInfo: "Ekstra Bilgiler",
  extraInfoPlaceholder: "Özel istekleriniz veya notlarınız...",
  maxCharacters: "Maksimum 500 karakter",
  makeReservation: "Rezervasyon Yap",
  dailyRental: "Günlük Kiralama",
  dailyRentalDesc: "Profesyonel şoförlü günlük araç kiralama hizmeti ile şehir içi ve şehirlerarası konforlu yolculuk",
  
  // Voucher
  reservationConfirmed: "Rezervasyonunuz Onaylandı!",
  voucherSent: "Voucher bilgileriniz e-posta adresinize gönderildi.",
  voucherNumber: "Voucher Numarası",
  secretCode: "Gizli Kod",
  voucherNote: "İptal veya değişiklik için voucher numaranız ve gizli kodunuzu kullanabilirsiniz.",
  backToHome: "Ana Sayfaya Dön",
  downloadVoucher: "Voucher'ı İndir",
  
  // My Reservations
  myReservations: "Rezervasyonlarım",
  checkReservation: "Rezervasyon Sorgula",
  enterVoucherInfo: "İptal veya değişiklik için voucher numaranızı ve gizli kodunuzu giriniz",
  enterVoucherNumber: "Voucher numaranızı girin",
  enterSecretCode: "Gizli kodunuzu girin",
  searchReservation: "Rezervasyon Ara",
  reservationDetails: "Rezervasyon Detayları",
  reservationStatus: "Durum",
  serviceType: "Hizmet Tipi",
  reservationDate: "Rezervasyon Tarihi",
  totalPrice: "Toplam Fiyat",
  cancelReservation: "Rezervasyonu İptal Et",
  modifyReservation: "Rezervasyonu Değiştir",
  statusActive: "Aktif",
  statusCancelled: "İptal Edildi",
  statusCompleted: "Tamamlandı",
  confirmCancel: "Rezervasyonu iptal etmek istediğinizden emin misiniz?",
  cancelSuccess: "Rezervasyon başarıyla iptal edildi",
  cancelError: "İptal işlemi sırasında bir hata oluştu",
  notFound: "Rezervasyon bulunamadı",
  invalidCredentials: "Voucher numarası veya gizli kod hatalı",
  
  // Quick Booking Form
  selectService: "Hizmet Seçin",
  searchContinue: "ARA / DEVAM ET",
  
  // Why Us
  whyUs: "Neden Biz?",
  personalizedExperience: "Kişiye Özel Seyahat Deneyimi",
  personalizedDesc: "Her müşterimize özel tasarlanmış seyahat planları sunuyoruz",
  wideDestinations: "Geniş Destinasyonlar",
  wideDestinationsDesc: "Türkiye'nin en güzel yerlerine ulaşım ve tur hizmetleri",
  comfortSafety: "Konfor & Güvenlik",
  comfortSafetyDesc: "Lüks araçlar ve profesyonel şoförlerle güvenli yolculuk",
  support247: "7/24 Destek",
  support247Desc: "Her an yanınızdayız, kesintisiz müşteri desteği",
  
  // Footer
  companyDesc: "Liberty Tour, Antalya merkezli olarak Türkiye çapında transfer, tur ve araç kiralama hizmetleri sunmaktadır.",
  quickLinks: "Hızlı Linkler",
  ourServices: "Hizmetlerimiz",
  supportLine: "Destek Hattı",
  followUs: "Bizi Takip Edin",
  allRightsReserved: "Tüm hakları saklıdır",
  privacyPolicy: "KVKK",
  termsConditions: "Sözleşmeler",
  
  // Common
  bookNow: "Hemen Rezervasyon",
  learnMore: "Detaylı Bilgi",
  viewAll: "Tümünü Gör",
  currency: "Para Birimi",
  price: "Fiyat",
  book: "Rezervasyon Yap",
  email: "E-posta",
  emailPlaceholder: "ornek@email.com",
  
  // Services Page
  servicesPageTitle: "Hizmetlerimiz",
  servicesPageDesc: "Türkiye'nin en güzel destinasyonlarında size özel hizmetler",
  
  // Private Tours Page
  privateToursTitle: "Özel Turlar",
  privateToursDesc: "Kişiye özel tasarlanmış tur programları ve profesyonel rehberli geziler",
  popularTours: "Popüler Turlarımız",
  discoverTurkey: "Türkiye'nin en güzel destinasyonlarını keşfedin",
  tourReservation: "Tur Rezervasyonu",
  tourSelection: "Tur Seçimi",
  selectTour: "Tur seçin",
  duration: "Süre",
  highlights: "Öne Çıkanlar",
  included: "Dahil Olanlar",
  specialRequests: "Özel İstekler",
  moreInfo: "Detaylı Bilgi",
  
  // Tour 1: Antalya City Tour
  tour1Name: "Antalya Şehir Turu",
  tour1Duration: "Tam Gün (8 Saat)",
  tour1Price: "Kişi başı €35",
  tour1Highlight1: "Kaleiçi Tarihi Merkez",
  tour1Highlight2: "Hadrian Kapısı",
  tour1Highlight3: "Düden Şelaleleri",
  tour1Highlight4: "Antalya Müzesi",
  tour1Include1: "Profesyonel rehber",
  tour1Include2: "Öğle yemeği",
  tour1Include3: "Giriş ücretleri",
  tour1Include4: "Otel transferleri",
  tour1Description: "Antalya'nın tarihi kalbini büyüleyici eski şehri, antik Roma kapıları ve muhteşem şelaleleriyle keşfedin. Bu tur, tarih, kültür ve doğal güzelliğin mükemmel bir karışımını sunar. Tarih meraklıları, fotoğrafçılar ve Akdeniz kıyısının otantik cazibesini keşfetmek isteyen aileler için idealdir.",
  
  // Tour 2: Cappadocia
  tour2Name: "Kapadokya 2 Günlük Tur",
  tour2Duration: "2 Gün / 1 Gece",
  tour2Price: "Kişi başı €120",
  tour2Highlight1: "Sıcak hava balonu turu",
  tour2Highlight2: "Yeraltı şehirleri",
  tour2Highlight3: "Göreme Açık Hava Müzesi",
  tour2Highlight4: "Peri bacaları",
  tour2Include1: "Gidiş-dönüş uçak bileti",
  tour2Include2: "Otel konaklaması",
  tour2Include3: "Tüm öğünler",
  tour2Include4: "Profesyonel rehber",
  tour2Include5: "Giriş ücretleri",
  tour2Description: "Kapadokya'nın eşsiz kaya oluşumları ve yeraltı şehirleriyle büyülü manzarasını deneyimleyin. Sıcak hava balonundan gün doğumunu izleyin ve antik mağara kiliselerini keşfedin. Macera arayanlar, romantizm arayan çiftler ve dünyanın en olağanüstü manzaralarından birine tanık olmak isteyen herkes için mükemmeldir.",
  
  // Tour 3: Pamukkale
  tour3Name: "Pamukkale & Hierapolis",
  tour3Duration: "Tam Gün (10 Saat)",
  tour3Price: "Kişi başı €50",
  tour3Highlight1: "Beyaz travertenler",
  tour3Highlight2: "Antik Hierapolis",
  tour3Highlight3: "Kleopatra Havuzu",
  tour3Include1: "Profesyonel rehber",
  tour3Include2: "Öğle yemeği",
  tour3Include3: "Giriş ücretleri",
  tour3Include4: "Otel transferleri",
  tour3Description: "Pamukkale'nin muhteşem beyaz kalsiyum teraslarını ve antik Roma şehri Hierapolis'i keşfedin. Sıcak travertenlerde yalınayak yürüyün ve efsanevi Kleopatra Havuzu'nda yüzün. Bu tur, doğa severler, sağlık meraklıları ve antik medeniyetler ile doğal harikalarla ilgilenenler için mükemmeldir.",
  
  // Tour 4: Istanbul
  tour4Name: "İstanbul Gezisi",
  tour4Duration: "2 Gün / 1 Gece",
  tour4Price: "Kişi başı €150",
  tour4Highlight1: "Sultanahmet Camii",
  tour4Highlight2: "Ayasofya",
  tour4Highlight3: "Topkapı Sarayı",
  tour4Highlight4: "Kapalıçarşı",
  tour4Include1: "Gidiş-dönüş uçak bileti",
  tour4Include2: "Otel konaklaması",
  tour4Include3: "Profesyonel rehber",
  tour4Include4: "Giriş ücretleri",
  tour4Description: "Doğu ile Batı'nın buluştuğu İstanbul'un zengin tarihi ve canlı kültürüne dalın. İkonik simgeleri ziyaret edin, hareketli çarşıları keşfedin ve bu muhteşem şehrin eşsiz atmosferini deneyimleyin. Kültür meraklıları, tarih tutkunları ve medeniyetlerin kesişim noktasını deneyimlemek isteyen gezginler için idealdir.",
  
  // Tour 5: Perge & Aspendos
  tour5Name: "Perge & Aspendos Antik Kentleri",
  tour5Duration: "Tam Gün (7 Saat)",
  tour5Price: "Kişi başı €40",
  tour5Highlight1: "Perge Antik Kenti",
  tour5Highlight2: "Aspendos Tiyatrosu",
  tour5Highlight3: "Roma mimarisi",
  tour5Include1: "Profesyonel rehber",
  tour5Include2: "Öğle yemeği",
  tour5Include3: "Giriş ücretleri",
  tour5Include4: "Otel transferleri",
  tour5Description: "Türkiye'nin en iyi korunmuş iki antik kentini keşfetmek için zamanda geriye gidin. Aspendos'un muhteşem Roma tiyatrosuna hayran kalın ve Perge kalıntıları arasında yürüyün. Bu tur, arkeoloji meraklıları, tarih severler ve antik medeniyetler ile klasik mimariyle ilgilenen aileler için mükemmeldir.",
  
  // Tour 6: Ephesus
  tour6Name: "Efes Antik Kenti",
  tour6Duration: "Tam Gün (12 Saat)",
  tour6Price: "Kişi başı €80",
  tour6Highlight1: "Celsus Kütüphanesi",
  tour6Highlight2: "Büyük Tiyatro",
  tour6Highlight3: "Artemis Tapınağı",
  tour6Include1: "Profesyonel rehber",
  tour6Include2: "Öğle yemeği",
  tour6Include3: "Giriş ücretleri",
  tour6Include4: "Otel transferleri",
  tour6Description: "Klasik dünyanın en muhteşem antik kentlerinden birini ziyaret edin. Antik Romalıların yürüdüğü mermer sokaklarda yürüyün ve muhteşem Celsus Kütüphanesi'ni görün. Bu tur, tarih meraklıları, arkeoloji severler ve antik Yunan ve Roma medeniyetlerine hayran olan herkes için idealdir.",
  
  // Tour 7: Antalya Aquarium
  tour7Name: "Antalya Akvaryum",
  tour7Duration: "4 Saat",
  tour7Price: "Kişi başı €40",
  tour7Highlight1: "Dünyanın en büyük tünel akvaryumu",
  tour7Highlight2: "Tropikal balık türleri",
  tour7Highlight3: "İnteraktif sergiler",
  tour7Highlight4: "Kar Dünyası deneyimi",
  tour7Include1: "Giriş biletleri",
  tour7Include2: "Otel transferleri",
  tour7Include3: "Profesyonel rehber",
  tour7Description: "Dünyanın en büyük akvaryum komplekslerinden birinde su altı dünyasına dalın. Köpekbalıkları ve vatozlarla çevrili muhteşem tünel akvaryumda yürüyün ve çeşitli deniz ekosistemlerini keşfedin. Çocuklu aileler, deniz yaşamı meraklıları ve eğitici ve eğlenceli bir deneyim arayanlar için mükemmeldir.",
  
  // Tour 8: Tazı Canyon
  tour8Name: "Tazı Kanyonu",
  tour8Duration: "6 Saat",
  tour8Price: "Kişi başı €45",
  tour8Highlight1: "400m derinliğinde kanyon manzaraları",
  tour8Highlight2: "Muhteşem panoramik görünümler",
  tour8Highlight3: "Doğa fotoğrafçılığı",
  tour8Highlight4: "Yürüyüş parkurları",
  tour8Include1: "Profesyonel rehber",
  tour8Include2: "Öğle yemeği",
  tour8Include3: "Otel transferleri",
  tour8Description: "Türkiye'nin en muhteşem doğal harikalarından biri olan Tazı Kanyonu'nun nefes kesici güzelliğini deneyimleyin. 400 metre derinliğindeki boğazın kenarında durun ve Toros Dağları'nın panoramik manzaralarının tadını çıkarın. Bu tur, doğa severler, fotoğrafçılar, macera arayanlar ve dramatik manzaralara değer verenler için mükemmeldir.",
  
  // Tour 9: St. Nicholas Memorial Museum
  tour9Name: "Aziz Nikolaos Anıt Müzesi",
  tour9Duration: "5 Saat",
  tour9Price: "Kişi başı €50",
  tour9Highlight1: "Orijinal Noel Baba Kilisesi",
  tour9Highlight2: "Bizans mimarisi",
  tour9Highlight3: "Myra Antik Kenti",
  tour9Highlight4: "Kayaya oyulmuş mezarlar",
  tour9Include1: "Profesyonel rehber",
  tour9Include2: "Öğle yemeği",
  tour9Include3: "Giriş ücretleri",
  tour9Include4: "Otel transferleri",
  tour9Description: "Noel Baba efsanesinin doğum yerini ziyaret edin ve Demre'deki Aziz Nikolaos'un antik kilisesini keşfedin. Bizans fresklerini ve yakındaki etkileyici kaya mezarlarıyla Myra antik kentini keşfedin. Aileler, tarih meraklıları, kültürel gezginler ve Hristiyan mirası ile antik medeniyetlerle ilgilenenler için idealdir.",
  
  // Tour 10: Köprülü Canyon
  tour10Name: "Tripl Park Köprülü Kanyon",
  tour10Duration: "8 Saat",
  tour10Price: "Kişi başı €65",
  tour10Highlight1: "Rafting",
  tour10Highlight2: "Zipline macerası",
  tour10Highlight3: "Kanyon yürüyüşü",
  tour10Highlight4: "Macera parkı aktiviteleri",
  tour10Include1: "Tüm ekipman",
  tour10Include2: "Profesyonel eğitmenler",
  tour10Include3: "Öğle yemeği",
  tour10Include4: "Sigorta",
  tour10Include5: "Otel transferleri",
  tour10Description: "Köprülü Kanyon'da aksiyon dolu bir günle adrenalininizi yükseltin. Heyecan verici rafting deneyimleyin, zipline ile havada süzülün ve muhteşem doğal ortamda çeşitli macera aktivitelerinin tadını çıkarın. Macera arayanlar, aktif gezginler, arkadaş grupları ve heyecan arayan gençleri olan aileler için mükemmeldir.",
  
  // Tour 11: Olympos - Çıralı
  tour11Name: "Olympos – Çıralı",
  tour11Duration: "8 Saat",
  tour11Price: "Kişi başı €55",
  tour11Highlight1: "Antik Olympos kalıntıları",
  tour11Highlight2: "Bozulmamış Çıralı plajı",
  tour11Highlight3: "Yanartaş sonsuz alevleri",
  tour11Highlight4: "Caretta caretta yuvalama alanı",
  tour11Include1: "Profesyonel rehber",
  tour11Include2: "Öğle yemeği",
  tour11Include3: "Giriş ücretleri",
  tour11Include4: "Otel transferleri",
  tour11Description: "Yemyeşil bir vadide yer alan mistik Olympos kalıntılarını keşfedin, el değmemiş Çıralı plajında rahatlayın ve Yanartaş'ın sonsuz alevlerine tanık olun. Bu eşsiz tur, tarihi, doğayı ve mitolojiyi birleştirir. Doğa severler, plaj meraklıları, aileler ve kültürel derinliği olan huzurlu bir kaçış arayanlar için mükemmeldir.",
  
  // Tour 12: Land of Legends
  tour12Name: "Land of Legends",
  tour12Duration: "8 Saat",
  tour12Price: "Kişi başı €70",
  tour12Highlight1: "Muhteşem su kaydırakları",
  tour12Highlight2: "Tema parkı eğlenceleri",
  tour12Highlight3: "Alışveriş caddesi",
  tour12Highlight4: "Eğlence gösterileri",
  tour12Include1: "Park girişi",
  tour12Include2: "Otel transferleri",
  tour12Include3: "Profesyonel rehber",
  tour12Description: "Heyecan verici su kaydırakları, heyecanlı tema parkı oyunları ve muhteşem gösterilerle nihai eğlence destinasyonunu deneyimleyin. Lüks alışveriş caddesini keşfedin ve dünya standartlarında eğlencenin tadını çıkarın. Bu tur, çocuklu aileler, heyecan arayanlar, arkadaş grupları ve eğlence ve heyecan dolu bir gün arayanlar için mükemmeldir.",
  
  // Group Tours Page
  groupToursTitle: "Grup Turları",
  groupToursDesc: "Ekonomik fiyatlarla grup turları ve günlük geziler",
  groupTypesTitle: "Grup Türlerimiz",
  groupTypesDesc: "Her grup için özel çözümler",
  schoolGroups: "Okul Grupları",
  schoolGroupsDesc: "Eğitici ve eğlenceli okul gezileri",
  corporateTrips: "Şirket Gezileri",
  corporateTripsDesc: "Kurumsal etkinlikler ve team building",
  familyGroups: "Aile Grupları",
  familyGroupsDesc: "Büyük aile buluşmaları ve özel günler",
  capacity: "Kişi Sayısı",
  educationalGuide: "Eğitici Rehber",
  safeTransfer: "Güvenli Transfer",
  lunch: "Öğle Yemeği",
  insurance: "Sigorta",
  professionalOrganization: "Profesyonel Organizasyon",
  luxuryVehicles: "Lüks Araçlar",
  catering: "Catering",
  activities: "Aktiviteler",
  flexibleProgram: "Esnek Program",
  childFriendly: "Çocuk Dostu",
  specialMenu: "Özel Menü",
  photoService: "Fotoğraf Servisi",
  groupPackagesTitle: "Grup Paketlerimiz",
  groupPackagesDesc: "Özel fiyatlarla grup indirimleri",
  noPackagesYet: "Henüz Paket Yok",
  packagesComingSoon: "Yakında grup paketleri eklenecek",
  hideInfo: "Bilgiyi Gizle",
  getQuote: "Teklif Al",
  groupTourRequest: "Grup Turu Talebi",
  groupType: "Grup Türü",
  selectGroupType: "Grup türü seçin",
  schoolGroup: "Okul Grubu",
  corporateGroup: "Şirket Grubu",
  familyGroup: "Aile Grubu",
  groupNameOrCompany: "Grup Adı / Kurum Adı",
  groupNamePlaceholder: "Grup veya kurum adı",
  participantCount: "Kişi Sayısı",
  authorizedPerson: "Yetkili Adı Soyadı",
  authorizedPersonPlaceholder: "Ad Soyad",
  phoneLabel: "Telefon",
  emailLabel: "E-posta",
  preferredDate: "Tercih Edilen Tarih",
  tourDuration: "Tur Süresi",
  selectDuration: "Süre seçin",
  halfDay: "Yarım Gün",
  fullDay: "Tam Gün",
  multiDay: "Çok Günlü",
  specialRequestsDetails: "Özel İstekler ve Detaylar",
  specialRequestsPlaceholder: "Grup hakkında detaylar, özel istekler, bütçe bilgisi...",
  maxChars: "Maksimum 500 karakter",
  processing: "İşleniyor...",
  sendQuoteRequest: "Teklif Talebi Gönder",
  
  // Car Rental Page
  carRentalTitle: "Araç Kiralama",
  carRentalDesc: "Antalya'da güvenli ve konforlu araç kiralama hizmeti",
  carCategoriesTitle: "Araç Kategorilerimiz",
  carCategoriesDesc: "İhtiyacınıza uygun aracı seçin",
  rentalAdvantagesTitle: "Kiralama Avantajları",
  rentalAdvantagesDesc: "Güvenli ve konforlu kiralama deneyimi",
  fullInsurance: "Tam Sigorta",
  fullInsuranceDesc: "Kapsamlı sigorta seçenekleri",
  flexibleDelivery: "Esnek Teslimat",
  flexibleDeliveryDesc: "Havalimanı, otel veya şehir merkezi",
  support247: "7/24 Destek",
  support247Desc: "Her zaman yanınızdayız",
  affordablePrice: "Uygun Fiyat",
  affordablePriceDesc: "Haftalık ve aylık indirimler",
  carRentalReservation: "Araç Kiralama Rezervasyonu",
  carCategory: "Araç Kategorisi",
  selectCarCategory: "Araç kategorisi seçin",
  perDay: "gün",
  pickupDate: "Alış Tarihi",
  pickupTime: "Alış Saati",
  returnDate: "Teslim Tarihi",
  returnTime: "Teslim Saati",
  pickupLocation: "Alış Noktası",
  selectPickupLocation: "Alış noktası seçin",
  returnLocation: "Teslim Noktası",
  selectReturnLocation: "Teslim noktası seçin",
  airport: "Antalya Havalimanı",
  cityCenter: "Şehir Merkezi",
  hotelDelivery: "Otel Teslimat",
  other: "Diğer",
  fullName: "Ad Soyad",
  phone: "Telefon",
  email: "E-posta",
  fullInsuranceExtra: "Tam Sigorta (+15€/gün)",
  gpsNavigation: "GPS Navigasyon (+5€/gün)",
  childSeat: "Çocuk Koltuğu (+3€/gün)",
  specialRequests: "Özel İstekler",
  specialRequestsPlaceholder: "Özel istekleriniz veya notlarınız...",
  maxCharacters: "Maksimum 500 karakter",
  makeReservation: "Rezervasyon Yap",
  processing: "İşleniyor...",
  noCarsYet: "Henüz Araç Yok",
  carsSoonAdded: "Yakında araçlar eklenecek",
  daily: "Günlük",
  
  // Villa Rental Page
  villaRentalTitle: "Villa Kiralama",
  villaRentalDesc: "Denize sıfır lüks villalar ve özel havuzlu tatil evleri",
  ourVillas: "Villalarımız",
  luxuryVillas: "Lüks ve konforlu villalar",
  villaReservation: "Villa Kiralama Rezervasyonu",
  checkIn: "Giriş Tarihi",
  checkOut: "Çıkış Tarihi",
  guests: "Misafir Sayısı",
  bedrooms: "Yatak Odası",
  bathrooms: "Banyo",
  privatePool: "Özel Havuz",
  seaView: "Deniz Manzarası",
  garden: "Bahçe",
  parking: "Otopark",
  wifi: "WiFi",
  kitchen: "Mutfak",
  villaCategories: "Villa Kategorileri",
  selectSuitableVilla: "Size uygun villayı seçin",
  people: "Kişi",
  night: "Gece",
  details: "Detaylar",
  villaCategory: "Villa Kategorisi",
  selectCategory: "Kategori seçin",
  checkInDate: "Giriş Tarihi",
  checkOutDate: "Çıkış Tarihi",
  adultsCount: "Yetişkin Sayısı",
  childrenCount: "Çocuk Sayısı",
  fullName: "Ad Soyad",
  fullNamePlaceholder: "Adınız ve soyadınız",
  phone: "Telefon",
  email: "E-posta",
  emailPlaceholder: "ornek@email.com",
  specialRequests: "Özel İstekler",
  specialRequestsPlaceholder: "Özel istekleriniz veya notlarınız...",
  maxCharacters: "Maksimum 500 karakter",
  processing: "İşleniyor...",
  makeReservation: "Rezervasyon Yap",
  
  // Yacht Rental Page
  yachtRentalTitle: "Yat Kiralama",
  yachtRentalDesc: "Lüks yatlar ve özel tekne turları ile unutulmaz deniz keyfi",
  ourYachts: "Yat Filomuz",
  luxuryYachts: "Lüks yatlar ve tekneler ile deniz keyfi",
  yachtReservation: "Yat Kiralama Rezervasyonu",
  tourDate: "Tur Tarihi",
  tourDuration: "Tur Süresi",
  selectDuration: "Süre seçin",
  halfDay: "Yarım Gün (4 Saat)",
  fullDay: "Tam Gün (8 Saat)",
  sunset: "Gün Batımı (2 Saat)",
  crew: "Mürettebat",
  captain: "Kaptan",
  meals: "Yemek",
  drinks: "İçecek",
  fishingEquipment: "Balık Tutma Ekipmanı",
  snorkelingGear: "Şnorkel Ekipmanı",
  musicSystem: "Müzik Sistemi",
  yachtFleet: "Yat Filomuz",
  yachtFleetDesc: "Lüks yatlar ve tekneler ile deniz keyfi",
  boatTours: "Tekne Turları",
  boatToursDesc: "Günlük tekne turları ve özel organizasyonlar",
  noYachtsYet: "Henüz Yat Yok",
  yachtsComingSoon: "Yakında yatlar eklenecek",
  noToursYet: "Henüz Tur Yok",
  toursComingSoon: "Yakında turlar eklenecek",
  yachtType: "Yat Tipi",
  selectYachtType: "Yat tipi seçin",
  motorYacht: "Motoryat",
  sailingYacht: "Yelkenli Yat",
  catamaran: "Katamaran",
  megaYacht: "Mega Yat",
  dailyTour: "Günlük Tur",
  sunsetTour: "Gün Batımı Turu",
  startDate: "Başlangıç Tarihi",
  endDate: "Bitiş Tarihi",
  departurePort: "Kalkış Limanı",
  selectPort: "Liman seçin",
  antalyaMarina: "Antalya Marina",
  kasPort: "Kaş Limanı",
  kalkanPort: "Kalkan Limanı",
  fethiyeMarina: "Fethiye Marina",
  bodrumMarina: "Bodrum Marina",
  passengerCount: "Kişi Sayısı",
  fullNameLabel: "Ad Soyad",
  fullNamePlaceholder: "Ad Soyad",
  phoneLabel: "Telefon",
  phonePlaceholder: "+90 555 123 45 67",
  emailLabel: "E-posta",
  emailPlaceholder: "ornek@email.com",
  cateringService: "Yiyecek-İçecek Servisi",
  waterSportsEquipment: "Su Sporları Ekipmanı (Jet Ski, Şnorkel)",
  professionalCrew: "Profesyonel Mürettebat",
  specialRequests: "Özel İstekler",
  specialRequestsPlaceholder: "Rota tercihleri, özel istekler...",
  maxCharacters: "Maksimum 500 karakter",
  processing: "İşleniyor...",
  makeReservation: "Rezervasyon Yap",
  rent: "Kirala",
  perDay: "/Gün",
  perHour: "/Saat",
  perPerson: "/Kişi",
  
  // About Page
  aboutSubtitle: "2019'dan beri Türkiye'de güvenilir ve kaliteli turizm hizmetleri",
  ourStory: "Hikayemiz",
  storyParagraph1: "Liberty Tour, 2019 yılında Antalya'da kurulmuş, Türkiye'nin önde gelen turizm şirketlerinden biridir. Kuruluşumuzdan bu yana, müşteri memnuniyetini her zaman ön planda tutarak, kaliteli ve güvenilir hizmet anlayışıyla sektörde öncü konumdayız.",
  storyParagraph2: "6 yılı aşkın deneyimimizle, 285.000'den fazla mutlu müşteriye hizmet verdik. 45'ten fazla araçtan oluşan modern filomuzla, havalimanı transferinden özel turlara, araç kiralamasından villa rezervasyonuna kadar geniş bir hizmet yelpazesi sunuyoruz.",
  storyParagraph3: "7/24 kesintisiz müşteri desteğimiz ve profesyonel ekibimizle, tatilinizin her anında yanınızdayız. Güvenlik, konfor ve müşteri memnuniyeti bizim için en önemli değerlerdir.",
  yearsExperience: "Yıllık Deneyim",
  happyCustomers: "Mutlu Müşteri",
  vehicleFleet: "Araç Filosu",
  support: "Destek",
  ourMission: "Misyonumuz",
  missionText: "Müşterilerimize en yüksek kalitede turizm hizmetleri sunarak, Türkiye'deki tatillerini unutulmaz kılmak. Güvenli, konforlu ve kişiye özel çözümlerle seyahat deneyimini mükemmelleştirmek.",
  ourVision: "Vizyonumuz",
  visionText: "Türkiye'nin en güvenilir ve tercih edilen turizm şirketi olmak. Yenilikçi hizmet anlayışımız ve müşteri odaklı yaklaşımımızla sektörde lider konumumuzu sürdürmek.",
  ourValues: "Değerlerimiz",
  valuesSubtitle: "Bizi biz yapan temel değerler",
  valueSecurity: "Güvenlik",
  valueSecurityDesc: "Müşterilerimizin güvenliği bizim için her şeyden önce gelir. Tüm araçlarımız düzenli bakımlı ve sigortalıdır.",
  valueCustomerFocus: "Müşteri Odaklılık",
  valueCustomerFocusDesc: "Müşteri memnuniyeti bizim önceliğimizdir. Her müşterimize özel çözümler üretiriz.",
  valueQuality: "Kalite",
  valueQualityDesc: "En yüksek kalite standartlarında hizmet sunmak için sürekli kendimizi geliştiririz.",
  valueProfessionalism: "Profesyonellik",
  valueProfessionalismDesc: "Deneyimli ve profesyonel ekibimizle her zaman en iyi hizmeti vermeye çalışırız.",
  valueInnovation: "Yenilikçilik",
  valueInnovationDesc: "Sektördeki yenilikleri takip eder ve hizmetlerimizi sürekli geliştiririz.",
  valueHonesty: "Dürüstlük",
  valueHonestyDesc: "Şeffaf ve dürüst iş anlayışımızla müşterilerimizin güvenini kazanırız.",
  
  // Blog Page
  blogSubtitle: "Seyahat ipuçları, destinasyon rehberleri ve turizm haberleri",
  blogPost1Title: "Antalya'da Gezilecek En İyi 10 Yer",
  blogPost1Excerpt: "Antalya'nın en güzel plajları, antik kentleri ve doğal güzellikleri. Tatilinizde mutlaka görmeniz gereken yerler.",
  blogPost1Date: "15 Ocak 2024",
  blogPost2Title: "Havalimanı Transferinde Dikkat Edilmesi Gerekenler",
  blogPost2Excerpt: "Güvenli ve konforlu bir havalimanı transferi için bilmeniz gereken tüm detaylar ve ipuçları.",
  blogPost2Date: "10 Ocak 2024",
  blogPost3Title: "Tekne Turu Rehberi: Akdeniz'in İncileri",
  blogPost3Excerpt: "Antalya kıyılarında yapabileceğiniz en güzel tekne turları ve görülmesi gereken koylar.",
  blogPost3Date: "5 Ocak 2024",
  blogPost4Title: "Araç Kiralama İpuçları ve Püf Noktaları",
  blogPost4Excerpt: "Tatilde araç kiralarken dikkat etmeniz gerekenler ve en uygun fiyatları bulma yolları.",
  blogPost4Date: "28 Aralık 2023",
  blogPost5Title: "Türkiye'nin En Güzel Özel Tur Rotaları",
  blogPost5Excerpt: "Kapadokya'dan Pamukkale'ye, Efes'ten Kaş'a Türkiye'nin en etkileyici tur rotaları.",
  blogPost5Date: "20 Aralık 2023",
  blogPost6Title: "Villa Tatili Planlaması: Bilmeniz Gerekenler",
  blogPost6Excerpt: "Mükemmel bir villa tatili için rezervasyon öncesi ve sonrası dikkat edilmesi gerekenler.",
  blogPost6Date: "15 Aralık 2023",
  blogCategoryGuide: "Rehber",
  blogCategoryTransfer: "Transfer",
  blogCategoryYacht: "Yat Turları",
  blogCategoryCarRental: "Araç Kiralama",
  blogCategoryPrivateTours: "Özel Turlar",
  blogCategoryVilla: "Villa",
  minutes: "dakika",
  readMore: "Devamını Oku",
  newsletterTitle: "Bültenimize Abone Olun",
  newsletterSubtitle: "En son kampanyalar ve seyahat ipuçlarından haberdar olun",
  subscribe: "Abone Ol",
  
  // Contact Page
  title: "İletişim",
  subtitle: "Size nasıl yardımcı olabiliriz? Bizimle iletişime geçin",
  phone: "Telefon",
  responseTime: "24 saat içinde yanıt",
  address: "Adres",
  officeHours: "Pazartesi - Pazar: 00:00 - 24:00",
  socialMedia: "Sosyal Medya",
  sendMessage: "Bize Mesaj Gönderin",
  messageSent: "Mesajınız başarıyla gönderildi! En kısa sürede size geri dönüş yapacağız.",
  messageError: "Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
  fullName: "Ad Soyad",
  fullNamePlaceholder: "Adınız ve soyadınız",
  subject: "Konu",
  selectSubject: "Konu seçin",
  tourServices: "Tur Hizmetleri",
  rentalServices: "Kiralama Hizmetleri",
  other: "Diğer",
  yourMessage: "Mesajınız",
  messagePlaceholder: "Mesajınızı buraya yazın...",
  characters: "karakter",
  sending: "Gönderiliyor...",
  visitUs: "Bizi Ziyaret Edin",
  visitUsSubtitle: "Ofisimize gelin, size yardımcı olmaktan mutluluk duyarız",
  formDescription: "Sorularınız, önerileriniz veya rezervasyon talepleriniz için formu doldurun.",
  success: "Başarılı!",
  successMessage: "Mesajınız başarıyla gönderildi. En kısa sürede size geri dönüş yapacağız.",
  error: "Hata!",
  errorMessage: "Mesaj gönderilemedi. Lütfen tekrar deneyin veya bizi doğrudan arayın.",
  findUs: "Bizi Bulun",
  whyChooseUs: "Neden Bizi Seçmelisiniz?",
  feature1Title: "7/24 Destek",
  feature1Desc: "Her zaman yanınızdayız, istediğiniz zaman bize ulaşabilirsiniz.",
  feature2Title: "Profesyonel Ekip",
  feature2Desc: "6+ yıllık deneyimli ekibimizle en iyi hizmeti sunuyoruz.",
  feature3Title: "Güvenilir Hizmet",
  feature3Desc: "285K+ mutlu müşteri ile kanıtlanmış kalite.",
  name: "Ad Soyad",
  namePlaceholder: "Adınızı ve soyadınızı girin",
  subjectPlaceholder: "Mesajınızın konusu",
  message: "Mesaj",
  send: "Mesaj Gönder",
  email: "E-posta",
  emailPlaceholder: "ornek@email.com"
};

export default trCommon;
